import { render, staticRenderFns } from "./TransferVdDialog.vue?vue&type=template&id=d6a4285a&scoped=true"
import script from "./TransferVdDialog.vue?vue&type=script&lang=ts"
export * from "./TransferVdDialog.vue?vue&type=script&lang=ts"
import style0 from "./TransferVdDialog.vue?vue&type=style&index=0&id=d6a4285a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a4285a",
  null
  
)

export default component.exports